<template>
  <MainLayout selectMenu="6-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <Row class="menu-line" type="flex">
        <Col flex="12" class="menu-actions ">
        <Button type="info" icon="md-cloud-download" size="small" @click.native="exportData()">{{ getTranslation('k025')
          }}</Button>&nbsp;
        </Col>        
        <Col flex="12" class="search-part">
          {{ getTranslation('k221') }}:&nbsp;<DatePicker size="small" transfer type="daterange" placement="bottom-end"
                            :placeholder="getTranslation('k220')" style="width: 210px" v-model="selectDate"
                            format="yyyy-MM-dd">
                        </DatePicker>&nbsp;
        {{ getTranslation('d016') }}：&nbsp;
        <Select :transfer="true" size="small"  v-model="operate_type" :filterable="true" :placeholder="getTranslation('m034')"
          style="width:150px" @on-change="getData()">          
          <Option v-for="(item,key) in operateTypeMap" :value="item.val" :key="key">{{ item.name }}</Option>
        </Select>&nbsp;        
        <Button type="primary" @click.native="getData()" size="small" shape="circle" icon="ios-search"></Button>
        </Col>
      </Row>
      <Affix>
      <Row class="table-header" type="flex">
        <Col flex="2" class="table-cell">{{ getTranslation('s002') }}
        </Col>
        <Col flex="3" class="table-cell">{{ getTranslation('s003') }}
        </Col>
        <Col flex="2" class="table-cell">{{ getTranslation('d016') }}
        </Col>
        <Col flex="12" class="table-cell">{{ getTranslation('s005') }}
        </Col>
        <Col flex="2" class="table-cell">{{ getTranslation('s006') }}
        </Col>
      </Row>
      </Affix>
      <Row v-for="(item,index) in history" :key="item.id" :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" type="flex">
        <Col flex="2" class="table-cell">{{ item.id }}
        </Col>
        <Col flex="3" class="table-cell">{{ item.username }}({{ item.user_id }})
        </Col>
        <Col flex="2" class="table-cell">{{ MapOperateType[item.operate_type] }}
        </Col>
        <Col flex="12" class="table-cell">{{showRemark(item) }}
        </Col>        
        <Col flex="2" class="table-cell">{{ item.created_string }}
        </Col>
      </Row>
      <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
        @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
        :page-size-opts=pageSizeAry>{{ getTranslation('c010') }} {{ total }} {{ getTranslation('c011') }}
      </Page>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import { API_URL, PAGE_SIZE_ARY } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters,mapState } from 'vuex'
import NoAuth from '@/components/NoAuth.vue'
import { postJsError,formatUTCDate,exportFile, blobToString } from '@/util/util.js'
export default {
  name: 'HistoryIndex', // 组件名称
  components: {
    MainLayout,  NoAuth,
  },
  props: {

  },
  data() {
    return {
      history: [],
      total: 0,
      pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
      current: 1,
      pageSizeAry: PAGE_SIZE_ARY,
      hasAuth: true,
      operate_type:-1,
      selectDate: [new Date(), new Date()],
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    ...mapState(['queryDate']),
    operateTypeMap() {
      return [
        {val:-1, name: this.getTranslation('k236')}      
      , {val:1, name: this.getTranslation('u045')}
      , {val:2, name: this.getTranslation('u048')}
      , {val:3, name: this.getTranslation('m104')}
      , {val:10, name: this.getTranslation('a202')}
      , {val:9, name: this.getTranslation('m152')}
      , {val:8, name: this.getTranslation('m153')}
      , {val:4, name: this.getTranslation('u051')}    
      , {val:5, name: this.getTranslation('u004')}
      , {val:6, name: this.getTranslation('p089')}
      , {val:7, name: this.getTranslation('i001')}      
      , {val:0, name: this.getTranslation('m127')}
      ]      
    },
    MapOperateType(){
      return {
        1: this.getTranslation('u045'),
        2: this.getTranslation('u048'),
        3: this.getTranslation('m104'),
        4: this.getTranslation('u051'),
        5: this.getTranslation('u004'),
        6: this.getTranslation('p089'),
        7: this.getTranslation('i001'),
        8: this.getTranslation('m153'),
        9: this.getTranslation('m152'),
        0: this.getTranslation('m127'),  
        10:  this.getTranslation('a202'),    
      }
    }
  },
  mounted() {
   
  },
  created() {
    this.setBreadcrumbItems();
    this.initData();
  },
  methods: {
    initData() {
      if (this.queryDate && this.queryDate.length > 0) {
        this.selectDate = [...this.queryDate]
      }
      this.getData();
    },
    getData() {
      
      let url = API_URL["historyGet"];
      let params = {
        page: this.current,
        page_size: this.pageSize,
        start: formatUTCDate(this.selectDate[0]),
        end: formatUTCDate(this.selectDate[1]),
        operate_type: this.operate_type,
      }
      this.$store.commit('setQueryDate', this.selectDate)
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.history = res.data.data && res.data.data.data || [];
            this.total = res.data.data.total;
            this.pageSize = res.data.data.pagination.page_size;
            this.current = res.data.data.pagination.page;
          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    showRemark(item) {
      if(!item.remark){
        return '';
      }
      let remark = item.remark;
      if(item.operate_type != 3 && item.operate_type !=8){        
        return remark;
      }
      try {        
        let obj = JSON.parse(remark);
        let parts = ""; 
        if(item.operate_type == 3) {      
          parts += this.getTranslation('m137')+`:「${obj.mac_id}」,`;        
          parts += this.getTranslation('m010')+`:「${obj.mac_code}」,`;
          parts += this.getTranslation('m138')+`: 「${obj.sw_version}」,`;
          if(obj.success === true){
            parts += this.getTranslation('m117');
          } else {
            parts += this.getTranslation('m118');
          }
        } else if(item.operate_type ==8){
          parts += this.getTranslation('m137')+`:「${obj.mac_id}」`;
          parts += this.getTranslation('m010')+`:「${obj.mac_code}」,`;
          parts += this.getTranslation('m198')+`: `;
          if(obj.hasProg === true){
            parts += '「'+this.getTranslation('k002')+'」';
          } 
          if(obj.hasSys === true){
            parts += '「'+this.getTranslation('k004')+'」';
          } 
          if(obj.hasSpot === true){
            parts += '「'+this.getTranslation('k246')+'」';
          }

        }
        return parts;
      } catch (e) {       
        return remark; // 如果解析失败，返回原始字符串
      }
    },
    handlePageChange(page) {
      this.current = page;
      this.getData();
    },
    handlePageSizeChange(pageSize) {
      this.current = 1;
      this.pageSize = pageSize;
      localStorage.setItem('user.page_size', this.pageSize)
      this.getData();
    },
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['s001']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('s001') }
        ])
      }     
    },
    async exportData(){
      let params = {        
          start: formatUTCDate(this.selectDate[0]),
          end: formatUTCDate(this.selectDate[1]),
          operate_type: this.operate_type,
      }
      let exportUrl = API_URL["historyExportData"];
      const response = await axios.get(exportUrl, {
          responseType: 'blob',
          params: params,
          timeout: 300000,
      });
      if (response.status == 200) {
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
          blobToString(response.data).then(text => {
            let msgData = JSON.parse(text);
            if (msgData.msg) {
              this.$Message.error(msgData.msg)
            }
          }).catch((err) => {
            postJsError(err)
            this.$Message.error(this.getTranslation('c001'));
          });
        } else {
          exportFile(response)
        }
      } else {
        this.$Message.error(this.getTranslation('c001'));
      }
    }
  }

}
</script>

<style scoped>
@import url("../../assets/style/list.css");
</style>
